import { RegistrationScreen } from '@/components/utils/RegistrationScreen';

export const RegistrationBundleInfo = () => {
  const primaryActionOnClick = () => alert('Acknowledged!');

  return (
    <RegistrationScreen
      title="This test kit is part of a bundle"
      description="The made-for-you products in your bundle will ship after your test results are released."
      content={<div data-testid="registrationBundleInfo-content" />}
      primaryActionLabel="I Acknowledge"
      primaryActionOnClick={primaryActionOnClick}
      data-testid="registrationBundleInfo-screen"
    />
  );
};
